import React from "react";
import {
  Dialog,
  Button,
  DialogTitle,
  DialogActions,
  Box,
  Typography,
  DialogContent,
  DialogContentText,
} from "@mui/material";

const CandidatosDniExistente = ({ open, onConfirm, onCancel, idSolicitud }) => {
  const ids = idSolicitud.split(",");
  const multiple = ids.length > 1 ? true : false;
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <Box justifyContent="center" backgroundColor="#1F618D">
        <DialogTitle>
          <Typography
            variant="h6"
            align="center"
            color="#ffffff"
            sx={{ fontWeight: "bold" }}
          >
            Ese DNI existe en {multiple ? "las" : "la"}{" "}
            {multiple ? "solicitudes" : "solicitud"} con{" "}
            {multiple ? "los" : "el"} {multiple ? "IDs" : "ID"} {idSolicitud}
          </Typography>
        </DialogTitle>
      </Box>
      <DialogContent>
        <DialogContentText textAlign={"center"}>
          ¿Quiere agregarlo de todas maneras?
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          variant="contained"
          onClick={onCancel}
          style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
        >
          Volver
        </Button>
        <Button
          style={{ color: "#ffffff" }}
          type="submit"
          onClick={onConfirm}
          variant="contained"
          color="primary"
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CandidatosDniExistente;
